<template>
    <client-page>
        <section class="section">
            <v-container>
                <company-view-card v-bind="{ company }" />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";

import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import CompanyViewCard from "@/components/client/companies/view/company-view-card.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        CompanyViewCard,
    },
    props: {
        _company: { type: String },
    },
    data: () => ({
        company: undefined,
    }),
    mounted() {
        this.init();
    },
    watch: {
        _company() {
            this.init();
        },
    },
    methods: {
        async init() {
            this.company = (await api.v1.companies.get({ _id: this._company }))?.company;
        },
    },
};
</script>

<style></style>
